import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from './button.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PreloadSpinnerModule } from '../preload-spinner/preload-spinner.module';

@NgModule({
  declarations: [
    ButtonComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    PreloadSpinnerModule,
    AngularSvgIconModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    ButtonComponent,
  ]
})
export class ButtonModule { }
